var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftRadiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 320,
    viewBox: "0 0 129 320",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.0435 0.981537C16.4153 39.6576 -23.3859 104.71 16.9024 155.847C34.5235 178.213 62.7086 194.997 86.0405 214.19C98.6973 224.603 111.031 235.998 116.776 249.334C125.764 270.189 114.944 288.842 99.0963 306.384C96.4307 309.335 98.5951 323.648 104.281 318.858C127.117 299.616 133.42 271.079 125.759 247.216C117.985 223.003 94.0288 204.436 70.5394 187C40.5934 164.775 8.49746 142.396 8.95469 109.299C9.48682 70.9501 42.3052 39.0838 72.6477 9.20763C74.336 7.54483 72.5614 -0.835369 70.0435 0.981537Z",
    fill: "#7064E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRadiant);
export default __webpack_public_path__ + "static/media/LeftRadiant.a61fddb0a7cd82348cec8889088e1a33.svg";
export { ForwardRef as ReactComponent };